import React from 'react'
import './Style/Report.css'
function Report({data,subTotal,discount,lastPrice,product}) {


  return <div className='report-info'>
      <h1> Payment Info:  </h1>
      <div className='info'>
          <div className='Payment-info'>
            <div>
              {data.map((item,key)=>(
                <p className='Payment'> {item.label }</p>
              ))}
            </div>
            <div>
              {data.map((item,key)=>(
                <span className='Payment'>: {item.value}</span>
              ))}
            </div>
          </div>
          <div className='data-report'>
              <div>
                <p className='infoproduct'> Sub Total </p>
                <p className='infoproduct'> Discount({product.discount}%) </p>
                <p className='grand-total'> Grand Total : </p>
              </div>
              <div>
                <span className='infoproduct'> ${subTotal} </span>
                <span className='infoproduct'> ${discount} </span>
                <span className='infoproduct'> ${lastPrice} </span>
              </div>
          </div>
      </div>
  </div>
}

export default Report